module.exports = __webpack_public_path__ + "static/media/sdxBg.a328bde9.png";